/* ELSA – Ürün detay sayfası davranışları */
import { CartLinesUpdateEvent } from '@shopify/events';

let moneyFormat = '';
const money = (cents, currency) => {
  const value = Number(cents || 0);
  if (moneyFormat) {
    const fmt = (n, decimals, thousands, dec) => {
      const fixed = (n / 100).toFixed(decimals);
      const [int, frac] = fixed.split('.');
      const withSep = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return frac ? withSep + dec + frac : withSep;
    };
    return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return fmt(value, 0, ',', '.');
        case 'amount_with_comma_separator': return fmt(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmt(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return fmt(value, 2, "'", '.');
        default: return fmt(value, 2, ',', '.');
      }
    });
  }
  try {
    return new Intl.NumberFormat('tr-TR', { style: 'currency', currency: currency || 'TRY' }).format(value / 100);
  } catch (e) {
    return (value / 100).toFixed(2) + ' TL';
  }
};

function initPdp(root) {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  // Ürün sayfasında sepete ekleyince yan sepeti aç (müşteri eklendiğini görsün, ödemeye tek tıkla geçsin)
  const enableDrawer = () => document.querySelector('cart-drawer-component')?.setAttribute('auto-open', '');
  enableDrawer();
  customElements.whenDefined('cart-drawer-component').then(enableDrawer);

  const dataEl = root.querySelector('[data-elsa-pdp-data]');
  const data = dataEl ? JSON.parse(dataEl.textContent) : { variants: [], currency: 'TRY' };
  const i18n = data.i18n || {};
  moneyFormat = data.moneyFormat || '';

  /* ---------- Galeri ---------- */
  const track = root.querySelector('[data-track]');
  const allSlides = track ? Array.from(track.querySelectorAll('[data-slide]')) : [];
  const allThumbs = Array.from(root.querySelectorAll('[data-thumb]'));
  const groupGallery = !!root.querySelector('[data-group-gallery]');
  let slides = allSlides.filter((s) => !s.hidden);
  let thumbs = allThumbs.filter((t) => !t.hidden);
  const counter = root.querySelector('[data-counter]');
  let current = 0;

  /* Seçili rengin görsel grubunu göster, diğer renklerin görsellerini gizle */
  const showGroup = (groupId) => {
    if (!groupGallery || !groupId) return false;
    const visible = (el) => !el.dataset.group || el.dataset.group === String(groupId);
    allSlides.forEach((s) => { s.hidden = !visible(s); });
    allThumbs.forEach((t) => { t.hidden = !visible(t); });
    slides = allSlides.filter((s) => !s.hidden);
    thumbs = allThumbs.filter((t) => !t.hidden);
    slides.forEach((s) => s.querySelector('img')?.setAttribute('loading', 'eager'));
    const first = slides.findIndex((s) => s.dataset.mediaId === String(groupId));
    if (track) track.scrollLeft = 0;
    setActive(Math.max(0, first));
    goTo(Math.max(0, first));
    return true;
  };

  const setActive = (index) => {
    current = index;
    thumbs.forEach((t, i) => {
      t.classList.toggle('is-active', i === index);
      if (i === index) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
  };
  const goTo = (index) => {
    if (!track || !slides[index]) return;
    track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    setActive(index);
  };
  if (track && slides.length) {
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current && slides[i]) setActive(i);
      });
    }, { passive: true });
  }
  allThumbs.forEach((t) => t.addEventListener('click', () => {
    const i = slides.findIndex((s) => s.dataset.mediaId === t.dataset.mediaId);
    if (i > -1) goTo(i);
  }));
  setActive(0);
  root.querySelector('[data-prev]')?.addEventListener('click', () => goTo(Math.max(0, current - 1)));
  root.querySelector('[data-next]')?.addEventListener('click', () => goTo(Math.min(slides.length - 1, current + 1)));

  /* ---------- Adet ---------- */
  const qty = root.querySelector('[data-qty]');
  root.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) - 1);
  });
  root.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    qty.value = (parseInt(qty.value, 10) || 1) + 1;
  });

  /* ---------- Varyantlar ---------- */
  const groups = Array.from(root.querySelectorAll('[data-option-index]'));
  const variantInput = root.querySelector('[data-variant-id]');
  const priceEl = root.querySelector('[data-price]');
  const compareEl = root.querySelector('[data-compare]');
  const saveEl = root.querySelector('[data-save]');
  const addBtn = root.querySelector('.elsa-pdp__add');
  const addLabel = addBtn?.querySelector('.add-to-cart-text__content span span') || addBtn?.querySelector('.add-to-cart-text__content');
  const stickyBtn = document.querySelector('[data-sticky-add]');
  const stickyPrice = document.querySelector('[data-sticky-price]');

  const setAvailability = (available) => {
    if (addBtn) addBtn.disabled = !available;
    if (addLabel) addLabel.textContent = available ? data.addText : data.soldText;
    if (stickyBtn) {
      stickyBtn.disabled = !available;
      stickyBtn.textContent = available ? data.addText : data.soldText;
    }
  };

  const updateVariant = () => {
    const selected = groups.map((g) => g.querySelector('input:checked')?.value || '');
    groups.forEach((g, i) => {
      const label = g.querySelector('[data-selected]');
      if (label) label.textContent = selected[i];
    });
    const variant = data.variants.find((v) => v.options.every((o, i) => String(o) === String(selected[i])));
    if (!variant) {
      setAvailability(false);
      return;
    }
    if (variantInput) variantInput.value = variant.id;
    const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
    if (priceEl) {
      priceEl.textContent = money(variant.price, data.currency);
      priceEl.classList.toggle('is-sale', !!onSale);
    }
    if (stickyPrice) stickyPrice.textContent = money(variant.price, data.currency);
    if (compareEl) {
      compareEl.hidden = !onSale;
      if (onSale) compareEl.textContent = money(variant.compare_at_price, data.currency);
    }
    if (saveEl) {
      saveEl.hidden = !onSale;
      if (onSale) saveEl.textContent = (i18n.discount || '%PCT').replace('PCT', Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100));
    }
    setAvailability(variant.available);
    if (variant.featured_media_id && !showGroup(variant.featured_media_id)) {
      const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.featured_media_id));
      if (idx > -1) goTo(idx);
    }
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    } catch (e) {}
  };
  groups.forEach((g) => g.querySelectorAll('input').forEach((r) => r.addEventListener('change', updateVariant)));

  /* ---------- Teslimat tahmini (İstanbul saati) ---------- */
  const eta = root.querySelector('[data-eta]');
  if (eta) {
    const lang = data.locale || 'tr';
    const dayFmt = new Intl.DateTimeFormat(lang, { weekday: 'long' });
    const fmt = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long' });
    const istanbulNow = () => {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'Europe/Istanbul', year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', hour12: false,
      }).formatToParts(new Date());
      const get = (t) => Number(parts.find((p) => p.type === t)?.value);
      return new Date(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'));
    };
    const isBusiness = (d) => d.getDay() !== 0 && d.getDay() !== 6;
    const addBusinessDays = (d, n) => {
      const r = new Date(d);
      while (n > 0) {
        r.setDate(r.getDate() + 1);
        if (isBusiness(r)) n--;
      }
      return r;
    };
    const render = () => {
      const now = istanbulNow();
      const cutoff = data.cutoffHour || 12;
      let ship = new Date(now);
      let line;
      if (isBusiness(now) && now.getHours() < cutoff) {
        const mins = cutoff * 60 - (now.getHours() * 60 + now.getMinutes());
        const h = Math.floor(mins / 60);
        const m = mins % 60;
        const time = `${h > 0 ? `${i18n.etaHours.replace('{h}', h)} ` : ''}${i18n.etaMinutes.replace('{m}', m)}`;
        line = i18n.etaToday.replace('{time}', time);
      } else {
        ship = addBusinessDays(now, 1);
        const tomorrow = new Date(now);
        tomorrow.setDate(now.getDate() + 1);
        const label = ship.toDateString() === tomorrow.toDateString() ? i18n.etaTomorrow : i18n.etaOn.replace('{day}', dayFmt.format(ship));
        line = i18n.etaLater.replace('{day}', label);
      }
      const from = addBusinessDays(ship, data.transitMin || 1);
      const to = addBusinessDays(ship, data.transitMax || 3);
      const range = from.getMonth() === to.getMonth()
        ? `${from.getDate()}–${fmt.format(to)}`
        : `${fmt.format(from)} – ${fmt.format(to)}`;
      eta.innerHTML = `${line}<br>${i18n.etaDelivery} <strong>${range}</strong>`;
    };
    render();
    setInterval(render, 60000);
  }

  /* ---------- Mobil sabit sepete ekle ---------- */
  const sticky = document.querySelector('[data-elsa-sticky]');
  const buyArea = root.querySelector('.elsa-pdp__buy');
  if (sticky && buyArea && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(([entry]) => {
      const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', passed);
      sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
    });
    io.observe(buyArea);
    stickyBtn?.addEventListener('click', () => addBtn?.click());
  }

  /* ---------- Birlikte al ---------- */
  const bundle = document.querySelector('[data-elsa-bundle]');
  if (bundle) {
    const checks = Array.from(bundle.querySelectorAll('[data-bundle-check]'));
    const totalEl = bundle.querySelector('[data-bundle-total]');
    const btn = bundle.querySelector('[data-bundle-add]');
    const msg = bundle.querySelector('[data-bundle-msg]');
    const recalc = () => {
      const chosen = checks.filter((c) => c.checked);
      const total = chosen.reduce((s, c) => s + Number(c.dataset.price), 0);
      if (totalEl) totalEl.textContent = money(total, data.currency);
      checks.forEach((c) => c.closest('.elsa-bundle__item')?.classList.toggle('is-off', !c.checked));
      if (btn) {
        btn.disabled = chosen.length === 0;
        btn.textContent = chosen.length > 1 ? i18n.addN.replace('{n}', chosen.length) : data.addText;
      }
    };
    checks.forEach((c) => c.addEventListener('change', recalc));
    recalc();

    btn?.addEventListener('click', async () => {
      const chosen = checks.filter((c) => c.checked);
      if (!chosen.length) return;
      // Ana ürün seçili varyantla eklenir
      const items = chosen.map((c) => ({
        id: Number(c.dataset.main === 'true' && variantInput ? variantInput.value : c.dataset.variant),
        quantity: 1,
      }));
      btn.disabled = true;
      if (msg) msg.textContent = '';
      const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
        .map((el) => el.dataset.sectionId)
        .filter(Boolean);
      const deferred = CartLinesUpdateEvent.createPromise();
      bundle.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: i.quantity })),
          promise: deferred.promise,
        })
      );
      try {
        const res = await fetch((window.Theme?.routes?.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items, sections: sectionIds.join(',') }),
        }).then((r) => r.json());
        const cart = await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            items: cart.items,
            source: 'product-form-component',
            sourceId: 'elsa-bundle',
            itemCount: items.length,
            productId: String(data.productId),
            sections: res.sections,
            didError: Boolean(res.status),
          },
        });
        if (res.status && msg) msg.textContent = res.description || res.message || i18n.bundleError;
      } catch (e) {
        deferred.reject(e);
        if (msg) msg.textContent = i18n.networkError;
      } finally {
        recalc();
      }
    });
  }
}

const boot = () => document.querySelectorAll('[data-elsa-pdp]').forEach(initPdp);
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
